import { Reducer } from '../../Reducer';
import { simpleOnGetRequest } from '../../utils';
import * as TYPES from './types';

const DEFAULT_STATE = {
    subdomainData: {},
    busy: false,
};

export default class WholesalerReducer extends Reducer {
    NAME = 'Wholesaler';

    alias = {
        [TYPES.WHOLESALER_SUBDOMAIN_GET_REQUEST]: 'onGetRequest',
        [TYPES.WHOLESALER_SUBDOMAIN_GET_SUCCESS]: 'onGetSuccess',
    };

    /**
     *
     * @param state
     * @param payload
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onGetRequest = simpleOnGetRequest(DEFAULT_STATE);

    /**
     *
     * @param state
     * @param action
     * @return {*|Immutable.Map<any, any>|Immutable.Map<string, boolean|Array>}
     */
    onGetSuccess = (state: any = DEFAULT_STATE, { payload: params }: any) =>
        state.set('subdomainData', params).set('busy', false);
}
